import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { setNoIndex } from '../utils/seo';
/**
 * Catch-all route. Previously an unmatched URL rendered a blank page, which
 * search engines treat as a soft 404. This gives crawlers (and visitors) a real
 * page with working links, explicitly marked noindex.
 */
export function NotFoundPage() {
  useEffect(() => {
    document.title = "Page Not Found | Mike's Pro Detail";
    setNoIndex();
  }, []);
  return <main className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white" data-id="element-1083" data-mp="31tixpvr5jt9i">
      <Navigation data-id="element-1084" data-mp="3gq9x450tt4z4" />
      <section className="pt-40 pb-24 px-4" data-id="element-1085" data-mp="3gqtglq64k1f9">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1086" data-mp="3brysq9tavmoa">
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6" data-id="element-1087" data-mp="3bqf7s5wp8ng6">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-1088" data-mp="1mdtwbjqsuj1n">
              Page Not Found
            </span>
          </h1>
          <div className="h-1 w-24 bg-red-600 rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)] mx-auto mb-6" data-id="element-1089" data-mp="wdk076oppwep" />
          <p className="text-lg text-gray-400 mb-10" data-id="element-1090" data-mp="10du3gbl4e8pv">
            The page you're looking for doesn't exist. Head back home or explore
            our mobile detailing services.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1091" data-mp="1a4ymbmdx2dpz">
            <Link to="/" className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1092" data-mp="1f1p186dzj39t">
              Back to Home
            </Link>
            <Link to="/services/mobile-detailing" className="px-8 py-4 bg-white text-black hover:bg-gray-200 font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1093" data-mp="1o1c1gouza31a">
              Our Services
            </Link>
          </div>
        </div>
      </section>
    </main>;
}